import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import MeetingLayout from './pages/MeetingLayout';
import OverviewPage from './pages/OverviewPage';
import AgendaPage from './pages/AgendaPage';
import AttendeesPage from './pages/AttendeesPage';
import HotelPage from './pages/HotelPage';
import SponsorsPage from './pages/SponsorsPage';
import SponsorDetailPage from './pages/SponsorDetailPage';
import GalleryPage from './pages/GalleryPage';
import ResourcesPage from './pages/ResourcesPage';
import FaqPage from './pages/FaqPage';
import LocalGuidePage from './pages/LocalGuidePage';
import UpcomingPage from './pages/UpcomingPage';
import OfflineBanner from './components/OfflineBanner';
import './App.css';

export default function App() {
  return (
    <>
      <OfflineBanner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/:slug" element={<MeetingLayout />}>
            {/* Nav lives in the shell now; the old tile-grid home redirects to Overview. */}
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<OverviewPage />} />
            <Route path="agenda" element={<AgendaPage />} />
            <Route path="attendees" element={<AttendeesPage />} />
            <Route path="hotel" element={<HotelPage />} />
            <Route path="sponsors" element={<SponsorsPage />} />
            <Route path="sponsors/:companySlug" element={<SponsorDetailPage />} />
            <Route path="gallery" element={<GalleryPage />} />
            <Route path="resources" element={<ResourcesPage />} />
            <Route path="faq" element={<FaqPage />} />
            <Route path="local-guide" element={<LocalGuidePage />} />
            <Route path="upcoming" element={<UpcomingPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}
